import { UserAgentApplication } from 'msal'
import { isIE } from './authHelper'
import { CONSULTANT_API_URL } from '../constants/config'
export const useRedirectFlow = isIE()

// For a full list of msal.js configuration parameters,
// visit https://azuread.github.io/microsoft-authentication-library-for-js/docs/msal/modules/_authenticationparameters_.html
export const msalAppRS = new UserAgentApplication({
  auth: {
    clientId: '30b1423b-822f-40fe-9649-970304c8688b',
    authority:
      'https://login.microsoftonline.com/a7886ee5-4e1e-45d4-8781-f8be94a82f0f',
    validateAuthority: true,
    redirectUri: process.env.REACT_APP_DEP_Remserv_DOMAIN_URL + '/consultant/login',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
})

export const msalAppMX = new UserAgentApplication({
  auth: {
    clientId: '30b1423b-822f-40fe-9649-970304c8688b',
    authority:
      'https://login.microsoftonline.com/a7886ee5-4e1e-45d4-8781-f8be94a82f0f',
    validateAuthority: true,
    redirectUri: process.env.REACT_APP_DEP_Maxxia_DOMAIN_URL + '/consultant/login',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
})
// Coordinates and required scopes for your web api
export const apiConfig = {
  resourceUri: CONSULTANT_API_URL + '/opportunity',
  resourceScope: 'api://a5206723-291b-49b9-bc56-3fad214db9cf/access_as_user',
}

/**
 * Scopes you enter here will be consented once you authenticate. For a full list of available authentication parameters,
 * visit https://azuread.github.io/microsoft-authentication-library-for-js/docs/msal/modules/_authenticationparameters_.html
 */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
}

// Add here scopes for access token to be used at the API endpoints.
export const tokenRequest = {
  scopes: [apiConfig.resourceScope, 'offline_access'],
}
